"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOverheadVouchers = exports.handlePreventNegativeCreditorBalance = exports.handleSavedUpVouchers = exports.getToVoucherTypeIds = exports.genResidueVouchers = exports.isProbablyLastDepositOnAccount = exports.findAndSort = exports.caseBillingIsActive = exports.getBaseBillingVoucher = exports.getVoucherWithInterest = exports.getCollectionCommissionMatches = void 0;
const moment_1 = __importDefault(require("moment"));
const uuid_1 = require("uuid");
const __1 = __importDefault(require(".."));
const case_vouchers_1 = require("../../case-vouchers");
const vouchers_1 = require("../../vouchers");
const utils_1 = require("../utils");
const interest_1 = require("../interest");
const tagIsActive = (tag, date) => {
    const from = tag.from != null ? (0, moment_1.default)(date).isAfter(tag.from) : true;
    const to = tag.to != null ? (0, moment_1.default)(date).isBefore(tag.to) : true;
    return from && to;
};
const getCollectionCommissionMatches = (billingModel, _case, caseVoucherWithDistribution) => {
    return billingModel.model.share.filter((share) => {
        const caseIsTagged = !share.caseTag ||
            (share.caseTag &&
                _case.tags.some((tag) => tag.tag === share.caseTag &&
                    tagIsActive(tag, caseVoucherWithDistribution.contraCaseVoucher.date)));
        const caseIsCompany = typeof share.caseIsCompany !== 'boolean' ||
            share.caseIsCompany === _case.isCompany;
        const caseVoucherIsTagged = !share.caseVoucherTag ||
            (share.caseVoucherTag &&
                caseVoucherWithDistribution &&
                caseVoucherWithDistribution.tags.some((tag) => tag.tag === share.caseVoucherTag &&
                    tagIsActive(tag, caseVoucherWithDistribution.contraCaseVoucher.date)));
        const caseVoucherHasCategory = !share.categories ||
            (share.categories &&
                caseVoucherWithDistribution &&
                share.categories.includes(caseVoucherWithDistribution.category));
        const caseVoucherIsOfVoucherType = !share.voucherTypeIds ||
            (share.voucherTypeIds &&
                caseVoucherWithDistribution &&
                share.voucherTypeIds.includes(caseVoucherWithDistribution.voucherTypeId));
        const caseVoucherSource = !share.caseVoucherSource ||
            share.caseVoucherSource === caseVoucherWithDistribution.source;
        return (caseIsTagged &&
            caseIsCompany &&
            caseVoucherIsTagged &&
            caseVoucherHasCategory &&
            caseVoucherIsOfVoucherType &&
            caseVoucherSource);
    });
};
exports.getCollectionCommissionMatches = getCollectionCommissionMatches;
const addInterest = (documents, expirationSettings) => (currState, prevState, voucher, nextVoucher) => {
    const until = (0, moment_1.default)(nextVoucher ? nextVoucher.date : voucher.date).format();
    const vouchersWithInterest = __1.default.interest.calculate(currState, documents, expirationSettings, until);
    return currState.map((voucher) => {
        const voucherWithInterest = vouchersWithInterest.find((v) => v.caseVoucherId === voucher.caseVoucherId);
        voucher.amount = voucherWithInterest
            ? voucherWithInterest.amount
            : voucher.amount;
        return voucher;
    });
};
const distributeWithInterest = (caseVouchers, documents, expirationSettings, billingModel) => {
    const modelPriorities = billingModel.model;
    let filters = [utils_1.sortBySameCategoryDateDescFirst];
    if (modelPriorities.voucherCategoryPriority) {
        const categoryPriority = modelPriorities.voucherCategoryPriority;
        filters = filters.concat((a, b) => (categoryPriority.findIndex((p) => p === a.category) || 0) -
            (categoryPriority.findIndex((p) => p === b.category) || 0));
    }
    if (modelPriorities.voucherTypePriority) {
        const typePriority = modelPriorities.voucherTypePriority;
        filters = filters.concat((a, b) => (typePriority.findIndex((p) => p === a.voucherTypeId) || 0) -
            (typePriority.findIndex((p) => p === b.voucherTypeId) || 0));
    }
    if (modelPriorities.voucherTagPriority) {
        const tagPriority = modelPriorities.voucherTagPriority;
        filters = filters.concat((a, b) => {
            const aTag = a.tags.filter((tag) => tagPriority.includes(tag.tag))[0] || null;
            const bTag = b.tags.filter((tag) => tagPriority.includes(tag.tag))[0] || null;
            return (((aTag &&
                aTag.tag &&
                tagPriority.findIndex((tag) => tag === aTag.tag)) ||
                0) -
                ((bTag &&
                    bTag.tag &&
                    tagPriority.findIndex((tag) => tag === bTag.tag)) ||
                    0));
        });
    }
    const dateFilter = (a, b) => modelPriorities.voucherDatePriorityNewFirst
        ? new Date(b.date).getTime() - new Date(a.date).getTime()
        : new Date(a.date).getTime() - new Date(b.date).getTime();
    filters = filters.concat([dateFilter, (a, b) => a.id - b.id]);
    return __1.default.distributor.distribute(caseVouchers, (0, utils_1.sortByWithExtraDiscriminator)(...filters), interest_1.distributePositiveReferenceVoucherPreInterest, addInterest(documents, expirationSettings));
};
const getVoucherWithInterest = (billingModel, caseVouchers, documents, expirationSettings) => (caseVouchers &&
    documents &&
    expirationSettings &&
    distributeWithInterest(__1.default.vouchers
        .postProcessing(caseVouchers, {
        includeIrrecoverableVouchers: false,
        includeDeletedVouchers: false,
        includeExpiredVouchers: false,
    })
        .filter((voucher) => {
        if (billingModel.model.excludeVoucherTypeIds) {
            return !billingModel.model.excludeVoucherTypeIds.some((excludeVoucherTypeId) => voucher.voucherTypeId.includes(excludeVoucherTypeId));
        }
        else {
            return true;
        }
    }), documents, expirationSettings, billingModel)) ||
    null;
exports.getVoucherWithInterest = getVoucherWithInterest;
const getBaseBillingVoucher = (baseVoucher, voucherWithDistribution, billingModel) => (Object.assign(Object.assign({}, baseVoucher), { billingModelId: billingModel.billingModelId, currency: voucherWithDistribution.contraCaseVoucher.currency, date: voucherWithDistribution.contraCaseVoucher.date, caseVoucherId: voucherWithDistribution.caseVoucherId, depositCaseVoucherId: voucherWithDistribution.contraCaseVoucher.caseVoucherId, caseVoucher: {
        caseVoucherId: voucherWithDistribution.caseVoucherId,
        voucherTypeId: voucherWithDistribution.voucherTypeId,
        date: voucherWithDistribution.date,
        id: voucherWithDistribution.id,
        referenceId: voucherWithDistribution.referenceId,
        source: voucherWithDistribution.source,
        amount: voucherWithDistribution.amount,
    }, depositCaseVoucher: mapDepositCaseVoucher(voucherWithDistribution.contraCaseVoucher) }));
exports.getBaseBillingVoucher = getBaseBillingVoucher;
const caseBillingIsActive = (date, _case) => _case.billingStartDate != null
    ? (0, moment_1.default)(date).isAfter(_case.billingStartDate)
    : true;
exports.caseBillingIsActive = caseBillingIsActive;
const findAndSort = (caseVouchers, voucherTypeIds) => {
    const vouchersOfType = voucherTypeIds
        ? caseVouchers.filter((v) => voucherTypeIds.includes(v.voucherTypeId))
        : caseVouchers;
    const vouchersWithDistribution = vouchersOfType
        .map((caseVoucher) => caseVoucher.distribution.map((caseVoucherWithDistribution) => {
        const v = caseVouchers.find((v) => v.caseVoucherId === caseVoucherWithDistribution.caseVoucherId);
        if (!v) {
            throw new Error('Could not find voucher in distribution');
        }
        return Object.assign(Object.assign({}, v), { contraCaseVoucher: caseVoucher, amountFromVoucher: caseVoucherWithDistribution.amount });
    }), [])
        .reduce((acc, vouchers) => acc.concat(vouchers), []);
    return vouchersWithDistribution.sort((0, utils_1.sortBy)((a, b) => new Date(a.contraCaseVoucher.date).getTime() -
        new Date(b.contraCaseVoucher.date).getTime(), (a, b) => a.id - b.id));
};
exports.findAndSort = findAndSort;
const isProbablyLastDepositOnAccount = (caseVouchers, documents, expirationSettings, date) => {
    const vouchers = __1.default.interest.calculate(caseVouchers, documents, expirationSettings, date);
    const isLast = __1.default.overview.balance(vouchers) > -4500;
    return isLast;
};
exports.isProbablyLastDepositOnAccount = isProbablyLastDepositOnAccount;
const genResidueVouchers = (shareAmount, voucherWithDistribution, shareBaseVoucher, billingModel, _case) => {
    const residueAmount = voucherWithDistribution.amountFromVoucher - shareAmount;
    const residueVoucherIsNotZero = residueAmount !== 0;
    const voucherIsNotCreditorTransaction = voucherWithDistribution.contraCaseVoucher.source !==
        case_vouchers_1.CaseVoucherSource.Creditor;
    if (residueVoucherIsNotZero &&
        (0, exports.caseBillingIsActive)(voucherWithDistribution.contraCaseVoucher.date, _case) &&
        voucherIsNotCreditorTransaction) {
        const newResidueVoucher = Object.assign(Object.assign({}, shareBaseVoucher), { billingVoucherId: (0, uuid_1.v4)(), billingModelId: billingModel.billingModelId, voucherTypeId: vouchers_1.VoucherTypeIds.DEPOSITPAYOUT, amount: Math.round(residueAmount) });
        if (newResidueVoucher.amount) {
            return newResidueVoucher;
        }
    }
    return null;
};
exports.genResidueVouchers = genResidueVouchers;
const getToVoucherTypeIds = (billingModel, voucherWithDistribution, collectionCommissionMatch) => {
    const toVoucherType = (billingModel.model.clientDepositToVoucherTypeId &&
        voucherWithDistribution.contraCaseVoucher.source ===
            case_vouchers_1.CaseVoucherSource.Creditor
        ? billingModel.model.clientDepositToVoucherTypeId
        : collectionCommissionMatch.toVoucherTypeId ||
            collectionCommissionMatch.toVoucherTypeIds) ||
        billingModel.model.toVoucherTypeId;
    const toVoucherTypeIds = typeof toVoucherType === 'string' ? [toVoucherType] : toVoucherType;
    return toVoucherTypeIds;
};
exports.getToVoucherTypeIds = getToVoucherTypeIds;
const handleSavedUpVouchers = (newResidueVouchers, savedUpVouchers) => {
    var _a;
    let newVouchers = [];
    for (let x = 0; x < newResidueVouchers.length; x++) {
        const newResidueVoucher = newResidueVouchers[x];
        for (let i = 0; i < savedUpVouchers.length; i++) {
            const savedUpVoucher = savedUpVouchers[i];
            if ((0, moment_1.default)(newResidueVoucher.date).isBefore((0, moment_1.default)(savedUpVoucher.date)))
                continue;
            const savedUpVoucherAmount = savedUpVoucher.amount > newResidueVoucher.amount * 0.8
                ? newResidueVoucher.amount * 0.8
                : savedUpVoucher.amount;
            if (!savedUpVoucherAmount)
                break;
            newVouchers = newVouchers.concat(Object.assign(Object.assign({}, savedUpVoucher), { billingVoucherId: (0, uuid_1.v4)(), currency: newResidueVoucher.currency, date: newResidueVoucher.date, caseVoucherId: newResidueVoucher.caseVoucherId, amount: savedUpVoucherAmount, details: Object.assign(Object.assign({}, savedUpVoucher.details), { savedUpVatAmount: savedUpVoucherAmount * 0.25, despositVoucherTypeId: (_a = newResidueVoucher.details) === null || _a === void 0 ? void 0 : _a.despositVoucherTypeId }) }));
            newResidueVouchers[x].amount -= savedUpVoucherAmount * 1.25;
            savedUpVouchers[i].amount -= savedUpVoucherAmount;
        }
        savedUpVouchers = savedUpVouchers.filter((savedUpVoucher) => !!savedUpVoucher.amount);
    }
    return [newResidueVouchers, savedUpVouchers, newVouchers];
};
exports.handleSavedUpVouchers = handleSavedUpVouchers;
const handlePreventNegativeCreditorBalance = (billingModel, amount, newCollectionCommissionVoucher, toVoucherTypeIds, share) => {
    if (billingModel.model.preventNegativeCreditorBalance) {
        const saveUpAmount = amount * 0.2;
        const savedUpVoucher = Object.assign(Object.assign({}, newCollectionCommissionVoucher), { shareId: share.shareId, billingVoucherId: undefined, amount: saveUpAmount, voucherTypeId: toVoucherTypeIds[0] });
        return [
            toVoucherTypeIds.map((toVoucherTypeId) => (Object.assign(Object.assign({}, newCollectionCommissionVoucher), { billingVoucherId: (0, uuid_1.v4)(), shareId: share.shareId, amount: amount - saveUpAmount, voucherTypeId: toVoucherTypeId, details: {
                    savedUpVoucher,
                    savedUpVatAmount: saveUpAmount,
                } }))),
            savedUpVoucher,
        ];
    }
    else {
        return [
            toVoucherTypeIds.map((toVoucherTypeId) => (Object.assign(Object.assign({}, newCollectionCommissionVoucher), { shareId: share.shareId, billingVoucherId: (0, uuid_1.v4)(), amount, voucherTypeId: toVoucherTypeId }))),
            null,
        ];
    }
};
exports.handlePreventNegativeCreditorBalance = handlePreventNegativeCreditorBalance;
const getOverheadVouchers = (baseVoucher, caseVoucherWithDistribution, _case, billingModel) => {
    let newOverheadVouchers = [];
    const caseVouchersOfType = billingModel.model.fromVoucherTypeIds
        ? caseVoucherWithDistribution.filter((v) => billingModel.model.fromVoucherTypeIds &&
            billingModel.model.fromVoucherTypeIds
                .concat(vouchers_1.VoucherTypeIds.REFUND)
                .includes(v.voucherTypeId))
        : caseVoucherWithDistribution;
    for (let i = 0; i < caseVouchersOfType.length; i++) {
        const caseVoucher = caseVouchersOfType[i];
        if (caseVoucher.distributionAmount < caseVoucher.amount &&
            (0, exports.caseBillingIsActive)(caseVoucher.date, _case) &&
            caseVoucher.source !== case_vouchers_1.CaseVoucherSource.Creditor) {
            newOverheadVouchers = newOverheadVouchers.concat(Object.assign(Object.assign({}, baseVoucher), { billingVoucherId: (0, uuid_1.v4)(), voucherTypeId: vouchers_1.VoucherTypeIds.OVERPAYMENT, date: caseVoucher.date, currency: caseVoucher.currency, amount: Math.round(caseVoucher.amount - caseVoucher.distributionAmount), depositCaseVoucherId: caseVoucher.caseVoucherId, depositCaseVoucher: mapDepositCaseVoucher(caseVoucher), billingModelId: billingModel.billingModelId }));
        }
    }
    return newOverheadVouchers;
};
exports.getOverheadVouchers = getOverheadVouchers;
const mapDepositCaseVoucher = (caseVoucher) => ({
    caseVoucherId: caseVoucher.caseVoucherId,
    date: caseVoucher.date,
    id: caseVoucher.id,
    referenceId: caseVoucher.referenceId,
    text: caseVoucher.text,
    source: caseVoucher.source,
    paymentType: caseVoucher.paymentType,
    paymentMethodId: caseVoucher.paymentMethodId,
    state: caseVoucher.state,
});
//# sourceMappingURL=helpers.js.map